// Old URLs keep working (spec §3.2, §9): each legacy path maps to exactly one
// new path, and no new path is itself redirected, so a redirect can never loop.
export interface LegacyRedirectRule {
  /** Route-relative path as used in <Route path>, e.g. "runs/:id". */
  from: string;
  /** Absolute target; ":name" segments are filled from the matched params. */
  to: string;
}

export const LEGACY_REDIRECTS: readonly LegacyRedirectRule[] = [
  { from: "runs", to: "/activity" },
  { from: "runs/:id", to: "/activity/:id" },
  { from: "dead-letter", to: "/attention" },
  { from: "organizations", to: "/clients" },
  { from: "organizations/:id", to: "/clients/:id" },
];

/** Fill a rule's `:name` segments from the matched route params, encoded. */
export function resolveRedirect(to: string, params: Readonly<Record<string, string | undefined>>): string {
  return to.replace(/:([A-Za-z]+)/g, (_, name: string) => encodeURIComponent(params[name] ?? ""));
}
